import {
  addSelectedDocument,
  removeSelectedDocument,
  setCurrentFolder,
  increaseDocumentDragCounter,
  decreaseDocumentDragCounter,
  increaseFileDragCounter,
  decreaseFileDragCounter,
  resetDragCounter,
} from './mutationTypes'

const mutations = {
  [addSelectedDocument](state, value) {
    state.selectedFile = value
  },

  [removeSelectedDocument](state) {
    state.selectedFile = null
  },

  [setCurrentFolder](state, id) {
    state.currentFolder = id
  },

  [increaseDocumentDragCounter](state) {
    state.documentDragCounter++
  },

  [decreaseDocumentDragCounter](state) {
    state.documentDragCounter--
  },

  [increaseFileDragCounter](state) {
    state.fileDragCounter++
  },

  [decreaseFileDragCounter](state) {
    state.fileDragCounter--
  },

  [resetDragCounter](state) {
    state.fileDragCounter = 0
    state.documentDragCounter = 0
  },
}

export default mutations
